module.exports = __webpack_public_path__ + "assets/images/01-balloon_1ac2d0f2753f5b8c8871c7758c0c5a11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/01-balloon.png
// module id = 172
// module chunks = 0